import {
  OnInit,
  Input,
  Component,
  OnDestroy,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MzToastService } from "ng2-materialize";
import { PlanningPokerService } from "../../services/planning-poker/planning-poker.service";
import { Subscription } from "rxjs";
import { PlanningPokerParticipant } from "../../interfaces/planningPokerParticipant";
import { PlanningPokerFeatureData } from "../../interfaces/planningPokerFeatureData";

@Component({
  selector: "app-planning-poker-toasts",
  template: "<div></div>",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanningPokerToastsComponent implements OnInit, OnDestroy {
  @Input() projectId: string;
  private participantJoined: Subscription;
  private participantLeft: Subscription;
  private estimationStarted: Subscription;

  constructor(
    private toastService: MzToastService,
    private planningPokerService: PlanningPokerService
  ) {}

  async ngOnInit() {
    this.participantJoined = this.planningPokerService.participantJoined.subscribe(
      (participant: PlanningPokerParticipant) => {
        this.toastService.show(
          participant.name + " ist online!",
          2000,
          "confirm-toast"
        );
      }
    );
    this.participantLeft = this.planningPokerService.participantLeft.subscribe(
      (participant: PlanningPokerParticipant) => {
        // this.toastService.show(participant.name + ' hat die Schätzrunde verlassen.', 2000, 'notification-toast');
      }
    );
    this.estimationStarted = this.planningPokerService.estimationStarted.subscribe(
      (feature: PlanningPokerFeatureData) => {
        // this.toastService.show('Schätzen für Item ' + feature.agirId + ' wurde gestartet.', 2000, 'confirm-toast');
        // this.toastService.show('Schätzen gestartet!', 2000, 'confirm-toast');
      }
    );
    await this.planningPokerService.watchProject(this.projectId);
  }

  async ngOnDestroy() {
    await this.planningPokerService.stopWatchingProject(this.projectId);
    this.participantJoined.unsubscribe();
    this.participantLeft.unsubscribe();
    this.estimationStarted.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/planning-poker-toasts/planning-poker-toasts.component.ts